import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { CARD_TITLE_SX } from './layout';

interface SectionHeaderProps {
  title: string;
  subtitle: string;
  linkLabel: string;
  onLinkClick: () => void;
}

export function SectionHeader({
  title,
  subtitle,
  linkLabel,
  onLinkClick,
}: SectionHeaderProps): ReactNode {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 3 }}>
      <Box>
        <Typography sx={CARD_TITLE_SX}>{title}</Typography>
        <Typography sx={{ color: 'text.secondary' }}>{subtitle}</Typography>
      </Box>
      <Button variant="text" onClick={onLinkClick} sx={{ flexShrink: 0 }}>
        {linkLabel}
      </Button>
    </Box>
  );
}
